import React, { useMemo } from 'react';
import { Card, Table, Row, Col, Statistic, Progress, Tag, Space } from 'antd';
import { BarChartOutlined, UserOutlined } from '@ant-design/icons';

interface RoleAnalytics {
  id: number;
  roleName: string;
  scriptCount: number;
  playCount: number;
  completionCount: number;
  branchCount: number;
  rewardCount: number;
  avgAffectionDelta: number;
}

const mockRoleAnalytics: RoleAnalytics[] = [
  {
    id: 1,
    roleName: '雨夜女王',
    scriptCount: 12,
    playCount: 1200,
    completionCount: 860,
    branchCount: 36,
    rewardCount: 48,
    avgAffectionDelta: 3.6,
  },
  {
    id: 2,
    roleName: '森林旅伴',
    scriptCount: 8,
    playCount: 780,
    completionCount: 520,
    branchCount: 24,
    rewardCount: 30,
    avgAffectionDelta: 2.4,
  },
  {
    id: 3,
    roleName: '都市秘书',
    scriptCount: 15,
    playCount: 1580,
    completionCount: 1020,
    branchCount: 45,
    rewardCount: 55,
    avgAffectionDelta: 4.1,
  },
];

const SocialRoleAnalytics: React.FC = () => {
  const summary = useMemo(() => {
    const totalScripts = mockRoleAnalytics.reduce((sum, item) => sum + item.scriptCount, 0);
    const totalPlays = mockRoleAnalytics.reduce((sum, item) => sum + item.playCount, 0);
    const totalComplete = mockRoleAnalytics.reduce((sum, item) => sum + item.completionCount, 0);
    const completionRate = totalPlays ? Math.round((totalComplete / totalPlays) * 100) : 0;
    const totalRewards = mockRoleAnalytics.reduce((sum, item) => sum + item.rewardCount, 0);
    return { totalScripts, totalPlays, completionRate, totalRewards };
  }, []);

  return (
    <div>
      <Card title="女主角色统计" extra={<Tag icon={<BarChartOutlined />}>社交后台</Tag>}>
        <Row gutter={16}>
          <Col span={6}>
            <Statistic title="剧本总数" value={summary.totalScripts} />
          </Col>
          <Col span={6}>
            <Statistic title="累计播放" value={summary.totalPlays} />
          </Col>
          <Col span={6}>
            <Statistic title="整体完成率" value={`${summary.completionRate}%`} />
          </Col>
          <Col span={6}>
            <Statistic title="奖励总数" value={summary.totalRewards} />
          </Col>
        </Row>
      </Card>

      <Card title="角色表现" style={{ marginTop: 16 }}>
        <Table
          rowKey="id"
          dataSource={mockRoleAnalytics}
          pagination={false}
          columns={[
            {
              title: '女主角色',
              dataIndex: 'roleName',
              key: 'roleName',
              render: (text: string) => (
                <Space>
                  <UserOutlined />
                  <span>{text}</span>
                </Space>
              ),
            },
            { title: '剧本数量', dataIndex: 'scriptCount', key: 'scriptCount' },
            { title: '播放次数', dataIndex: 'playCount', key: 'playCount' },
            { title: '完成人数', dataIndex: 'completionCount', key: 'completionCount' },
            {
              title: '完成率',
              key: 'completionRate',
              render: (_: any, record: RoleAnalytics) => {
                const rate = record.playCount
                  ? Math.round((record.completionCount / record.playCount) * 100)
                  : 0;
                return <Progress percent={rate} size="small" />;
              },
            },
            { title: '支线数量', dataIndex: 'branchCount', key: 'branchCount' },
            { title: '奖励数量', dataIndex: 'rewardCount', key: 'rewardCount' },
            { title: '平均亲密度变化', dataIndex: 'avgAffectionDelta', key: 'avgAffectionDelta' },
          ]}
        />
      </Card>
    </div>
  );
};

export default SocialRoleAnalytics;









